import React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/home/runner/work/bthinking/bthinking/src/components/mdx/MDXPageLayout";
import { Icon, colors } from "bold-ui";
import { Card } from "../../components/Card";
import { IconTitle } from "../../components/IconTitle";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <h1 {...{
      "id": "principios",
      "style": {
        "position": "relative"
      }
    }}>{`Princípios`}</h1>
    <p>{`O coração do Lean UX é um conjunto de princípios.
Equipes guiadas por estes princípios conseguem tirar melhor proveito do processo.
Não basta apenas aplicar diferentes métodos em uma ordem específica, é importante incorporar estes princípios para que o uso do B_thinking tenha sucesso.`}</p>
    <IconTitle icon="multipleUsers" iconColor={colors.purple.c50} mdxType="IconTitle">
  Equipes multifuncionais, mas pequenas
    </IconTitle>
    <ul>
      <li parentName="ul">{`É importante ter colaboração entre diferentes disciplinas, isso evita o efeito cascata, uma vez que as ideias são discutidas com todos os stakeholders. `}</li>
      <li parentName="ul">{`Equipes pequenas, para permitir uma comunicação mais eficaz e manter todos atualizados sobre mudanças e novos conhecimentos.`}</li>
      <li parentName="ul">{`As equipes recebem problemas para resolver e não funcionalidades para desenvolver. `}</li>
    </ul>
    <IconTitle icon="dropFilled" fill="primary" mdxType="IconTitle">
  Sem desperdícios, foco no resultado
    </IconTitle>
    <ul>
      <li parentName="ul">{`Os resultados visam entregar valor aos stakeholders.`}</li>
      <li parentName="ul">{`Atividades que não agregam valor são despriorizadas.`}</li>
      <li parentName="ul">{`Foco no MVP e entregas constantes incrementando o produto com base nas necessidades dos usuários.`}</li>
    </ul>
    <IconTitle icon="microphoneFilled" iconColor={colors.orange.c50} mdxType="IconTitle">
  Conhecimento é compartilhado, trabalho é colaborativo
    </IconTitle>
    <ul>
      <li parentName="ul">{`A equipe  amadurece junto em relação ao produto, cliente e usuários. `}</li>
      <li parentName="ul">{`É essencial ter boa comunicação e expressar as ideias e conhecimentos com clareza. `}</li>
      <li parentName="ul">{`Gurus que querem brilhar sozinhos e não compartilham informação não tem espaço nessa equipe.`}</li>
    </ul>
    <IconTitle icon="presentationFilled" iconColor={colors.green.c50} mdxType="IconTitle">
  Testar antes, escalar depois
    </IconTitle>
    <ul>
      <li parentName="ul">{`É importante testar as hipóteses antes de escalá-las. `}</li>
      <li parentName="ul">{`Ter liberdade para experimentar soluções sem ser penalizado se as ideias não tiveram sucesso.`}</li>
      <li parentName="ul">{`É criado apenas o produto viável mínimo (MVP), garantindo economia de tempo e recursos.`}</li>
    </ul>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      